import { getCookieChild, ready, setCookie, ifSelectorExist, getElements, getElement } from "./utils";
import { locationModal } from "./location-modal-window";
import { nextDoorEvent } from "./nextdoor-cf7-event";
import { hvacSliders } from "./sliders";


ready(() => {
  locationModal();
  hvacSliders();
});

nextDoorEvent();



document.addEventListener('wpcf7mailsent', function (event) {
  // Check if the form submission is successful and the cookie for selectedCity is Indianapolis
  if (getCookieChild('selectedCity') === 'Indianapolis') {
    // Create the script element
    var pixelScript = document.createElement('script');
    pixelScript.type = 'text/javascript';
    pixelScript.async = true;
    pixelScript.src = "//pixel.admedia.com/w.php?ai=19790&ct=Lead&cv=";

    // Append the script to the body or head
    document.body.appendChild(pixelScript);
  }

  if (getCookieChild('selectedCity') === 'Columbus') {
    // Create the script element
    var pixelScript = document.createElement('script');
    pixelScript.type = 'text/javascript';
    pixelScript.async = true;
    pixelScript.src = "//pixel.admedia.com/w.php?ai=19792&ct=Lead&cv=";

    // Append the script to the body or head
    document.body.appendChild(pixelScript);
  }
}, false);


function setEmailFromCookie(selectedEmail) {
  // If selectedEmail is available, set it to inputs
  if (selectedEmail) {
    const formRecipients = document.querySelectorAll('input.form_recipient');
    if (formRecipients != undefined && formRecipients != null) {
      formRecipients.forEach((inputElement) => {
        inputElement.value = decodeURIComponent(selectedEmail);
      });
    }
  }
}


let setDefaultValueForCitySelect = () => {
  // Get the saved city from cookies
  var savedCity = getCookieChild('selectedCity');

  // If there's a saved city, set it as selected
  if (savedCity) {
    var selectElement = document.getElementById('city-select');
    if (ifSelectorExist(selectElement)) {
      for (var i = 0; i < selectElement.options.length; i++) {
        if (selectElement.options[i].text === savedCity) {
          selectElement.selectedIndex = i;
          break;
        }
      }
    }
  }
}


export let citySelectEvent = () => {
  // Listen for the change event on the select box
  if (ifSelectorExist(document.getElementById('city-select'))) {
    document.getElementById('city-select').addEventListener('change', function () {
      // Get the selected option
      var selectedOption = this.options[this.selectedIndex];

      // Get the data attributes
      var city = selectedOption.textContent;
      var phone = selectedOption.getAttribute('data-phone');
      var email = selectedOption.getAttribute('data-email');

      replacePhoneNumbers(phone);
      setEmailFromCookie(email);
      replaceKeywordsWithCity(city);
      // Set cookies
      setCookie('selectedCity', city, 3);
      setCookie('selectedPhone', phone, 3);
      setCookie('selectedEmail', email, 3);


    });
  }
}


// Function to replace phone numbers
function replacePhoneNumbers(newPhone) {
  if (newPhone != null && newPhone !== undefined) {
    // Convert new phone to a simple format
    var simpleNewPhone = newPhone.replace(/[^0-9]/g, "");

    // Convert simpleNewPhone to formatted string (317) 680 8033
    var formattedNewPhone = `(${simpleNewPhone.slice(0, 3)}) ${simpleNewPhone.slice(3, 6)} ${simpleNewPhone.slice(6, 10)}`;

    // Fetch all elements with the tag 'a'
    var anchors = document.querySelectorAll("a");

    // Regex for detecting phone numbers
    var formattedOldPhoneRegex = /(\+?1?[-.\s]?(\()?[-.\s]?[0-9]{3}[-.\s]?(\))?[-.\s]?[0-9]{3}[-.\s]?[0-9]{4})/g;

    // Loop through each anchor tag
    anchors.forEach(function (anchor) {
      // Loop through each child node in the anchor
      for (const node of anchor.childNodes) {
        // Check if the node is a text node
        if (node.nodeType === 3) {
          var oldPhoneText = node.nodeValue;
          if (oldPhoneText.match(formattedOldPhoneRegex)) {
            // Replace only the phone number in the text node
            node.nodeValue = oldPhoneText.replace(formattedOldPhoneRegex, formattedNewPhone);
          }
        }
      }

      var oldPhoneHref = anchor.getAttribute("href");
      // Replace in href attribute
      if (oldPhoneHref && oldPhoneHref.match(formattedOldPhoneRegex)) {
        anchor.setAttribute("href", `tel:${formattedNewPhone}`);
      }
    });
  }
}

function replaceKeywordsWithCity(cityName) {


  if (!cityName) {
    return; // Exit if cityName is not set
  }

  const keywords = [
    'around Indianapolis',
    'Bassett’s Indianapolis',
    'chilly Indiana',
    'chilly Plainfield',
    'Cost in Indiana',
    'in Indiana',
    'in Indianapolis at',
    'in Indianapolis, IN',
    'in Indianapolis, Indiana',
    'in Plainfield, IN',
    'in Plainfield, Indiana',
    'Plainfield, Indiana',
    'Indiana home',
    'Indiana’s reputable',
    'Indianapolis Area',
    'Indianapolis, IN',
    'Indianapolis, Indiana',
    'Indianapolis, Indiana’s',
    'info@bassettservices.com',
    'Local Indianapolis',
    'local Indianapolis',
    'my Indianapolis',
    'Near Indianapolis',
    'near Indianapolis',
    'Near Indianapolis, Indiana',
    'near Plainfield, Indiana',
    'of Indianapolis',
    'of Plainfield, Indiana',
    'Plainfield documented',
    'Plainfield experiences',
    'Plainfield hover',
    'Plainfield shivered',
    'Plainfield, IN',
    'Plainfield, Indiana, like',
    'seasoned Indiana',
    'Services in Indiana',
    'Serving Plainfield, IN',
    'skilled Indianapolis',
    'the Indianapolis',
    'the Indianapolis vicinity',
    'the Indianapolis, Indiana Area',
    'to Indianapolis',
    'Trust Indianapolis, Indiana',
    'unforgiving Indiana',
    'West Indiana',
    'why Indianapolis',
    'your Indiana',
    'Your Indianapolis, Indiana'
  ];


  function replaceText(node) {
    let modifiedText = node.nodeValue;


    keywords.forEach((keyword) => {
      // Use word boundaries to prevent partial matches
      const regExp = new RegExp('\\b' + keyword + '\\b', 'gi');

      // Replace only if the entire keyword is found
      modifiedText = modifiedText.replace(regExp, (match) => {
        return match.replace(/Indianapolis|Plainfield|Indiana/gi, cityName);
      });
    });

    // Remove the parts you don't want in the final text
    const removableParts = [', IN', ', Indiana', ', Indiana’s', ', Indiana Area'];
    removableParts.forEach((part) => {
      const regExp = new RegExp(part, 'g');
      modifiedText = modifiedText.replace(regExp, '');
    });

    node.nodeValue = modifiedText;
  }




  function walk(node) {
    // Skip nodes inside a select element
    if (node.parentNode && node.parentNode.tagName === 'SELECT') {
      return;
    }

    // Climb up the DOM tree to check if any parent has the .skip-city-replace class
    let ancestor = node.parentNode;
    while (ancestor != null) {
      if (ancestor.classList && ancestor.classList.contains('skip-city-replace')) {
        return; // Skip this node and all its descendants
      }
      ancestor = ancestor.parentNode;
    }

    // Continue with the original logic if .skip-city-replace is not found
    if (node.nodeType === 3) { // Check if it's a text node
      replaceText(node);
    }
    node = node.firstChild;
    while (node) {
      walk(node);
      node = node.nextSibling;
    }
  }


  function replaceDuplicateCity(cityName) {
    if (!cityName) {
      return; // Exit if cityName is not set
    }
    console.log('replace dublicates')

    function replaceText(node) {
      const regExp = new RegExp(`${cityName},\\s*${cityName}`, 'gi'); // Regexp to match "Plainfield, Plainfield"
      node.nodeValue = node.nodeValue.replace(regExp, cityName);
    }

    function walk(node) {
      if (node.nodeType === 3) {
        replaceText(node);
      }
      node = node.firstChild;
      while (node) {
        walk(node);
        node = node.nextSibling;
      }
    }

    walk(document.body);
  }



  walk(document.body);
  console.log('replace city name text')
  replaceDuplicateCity(cityName)
}

let installThePixel = (selectedCity) => {

  console.log('installThePixel == ', selectedCity)
  let head = document.querySelector('#site-head');
  var pixelScript = document.createElement('script');
  pixelScript.type = 'text/javascript';
  pixelScript.async = true;

  switch (selectedCity) {
    case 'Indianapolis':
      pixelScript.src = "//pixel.admedia.com/w.php?ai=19790&ct=Lead&cv=";
      document.body.appendChild(pixelScript);

      // First Nextdoor Pixel Code
      var nextdoorScript1 = document.createElement('script');
      nextdoorScript1.type = 'text/javascript';
      nextdoorScript1.innerHTML = `
        (function(win, doc, sdk_url){
          if(win.ndp) return;
          var tr=win.ndp=function(){
            tr.handleRequest? tr.handleRequest.apply(tr, arguments):tr.queue.push(arguments);
          };
          tr.queue = [];
          var s='script';
          var new_script_section=doc.createElement(s);
          new_script_section.async=!0;
          new_script_section.src=sdk_url;
          var insert_pos=doc.getElementsByTagName(s)[0];
          insert_pos.parentNode.insertBefore(new_script_section, insert_pos);
        })(window, document, 'https://ads.nextdoor.com/public/pixel/ndp.js');
        
        ndp('init','3ad23803-3e4a-41a1-a11e-f97ca59d5533', {});
        ndp('track','PAGE_VIEW');
      `;
      head.appendChild(nextdoorScript1);

      var noscript1 = document.createElement('noscript');
      var noscript1Img = document.createElement('img');
      noscript1Img.height = "1";
      noscript1Img.width = "1";
      noscript1Img.style.display = "none";
      noscript1Img.src = "https://flask.nextdoor.com/pixel?pid=3ad23803-3e4a-41a1-a11e-f97ca59d5533&ev=PAGE_VIEW&noscript=1";
      noscript1.appendChild(noscript1Img);
      head.appendChild(noscript1);

      // Second Nextdoor Pixel Code
      var nextdoorScript2 = document.createElement('script');
      nextdoorScript2.type = 'text/javascript';
      nextdoorScript2.innerHTML = `
        (function(win, doc, sdk_url){
          if(win.ndp) return;
          var tr=win.ndp=function(){
            tr.handleRequest? tr.handleRequest.apply(tr, arguments):tr.queue.push(arguments);
          };
          tr.queue = [];
          var s='script';
          var new_script_section=doc.createElement(s);
          new_script_section.async=!0;
          new_script_section.src=sdk_url;
          var insert_pos=doc.getElementsByTagName(s)[0];
          insert_pos.parentNode.insertBefore(new_script_section, insert_pos);
        })(window, document, 'https://ads.nextdoor.com/public/pixel/ndp.js');
        
        ndp('init','6d585239-6130-4772-8722-0ba85337b160', {});
        ndp('track','PAGE_VIEW');
      `;
      head.appendChild(nextdoorScript2);

      var noscript2 = document.createElement('noscript');
      var noscript2Img = document.createElement('img');
      noscript2Img.height = "1";
      noscript2Img.width = "1";
      noscript2Img.style.display = "none";
      noscript2Img.src = "https://flask.nextdoor.com/pixel?pid=6d585239-6130-4772-8722-0ba85337b160&ev=PAGE_VIEW&noscript=1";
      noscript2.appendChild(noscript2Img);
      head.appendChild(noscript2);

      break;
      pixelScript.src = "//pixel.admedia.com/w.php?ai=19790&ct=Lead&cv=";
      document.body.appendChild(pixelScript);

      var nextdoorScript1 = document.createElement('script');
      nextdoorScript1.type = 'text/javascript';
      nextdoorScript1.innerHTML = `
          (function(win, doc, sdk_url){
            if(win.ndp) return;
            var tr=win.ndp=function(){
              tr.handleRequest? tr.handleRequest.apply(tr, arguments):tr.queue.push(arguments);
            };
            tr.queue = [];
            var s='script';
            var new_script_section=doc.createElement(s);
            new_script_section.async=!0;
            new_script_section.src=sdk_url;
            var insert_pos=doc.getElementsByTagName(s)[0];
            insert_pos.parentNode.insertBefore(new_script_section, insert_pos);
          })(window, document, 'https://ads.nextdoor.com/public/pixel/ndp.js');
          
          ndp('init','3ad23803-3e4a-41a1-a11e-f97ca59d5533', {});
          ndp('track','PAGE_VIEW');
        `;
      head.appendChild(nextdoorScript1);

      var noscript1 = document.createElement('noscript');
      var noscript1Img = document.createElement('img');
      noscript1Img.height = "1";
      noscript1Img.width = "1";
      noscript1Img.style.display = "none";
      noscript1Img.src = "https://flask.nextdoor.com/pixel?pid=3ad23803-3e4a-41a1-a11e-f97ca59d5533&ev=PAGE_VIEW&noscript=1";
      noscript1.appendChild(noscript1Img);
      head.appendChild(noscript1);
      break;
    case 'Columbus':
      pixelScript.src = "//pixel.admedia.com/w.php?ai=19792&ct=Lead&cv=";
      document.body.appendChild(pixelScript);

      var additionalScript = document.createElement('script');
      additionalScript.type = 'text/javascript';
      additionalScript.src = "https://a.remarketstats.com/px/smart/?c=260a7915d14c867";
      document.body.appendChild(additionalScript);
      break;
    case 'Cincinnati':
      pixelScript.src = "//pixel.admedia.com/w.php?ai=20250&ct=Lead&cv=";
      document.body.appendChild(pixelScript);
      break;
    // Add more cases as needed for other cities
    default:
      console.log('City not recognized or no action required for the selected city.');
  }
}

// Get the selected phone from cookies
let selectedCity = getCookieChild('selectedCity');
let selectedPhone = getCookieChild('selectedPhone');
let selectedEmail = getCookieChild('selectedEmail');

if (!selectedCity || !selectedPhone || !selectedEmail) {
  let headTag = document.getElementById('site-head');
  if (headTag) {
    let headCity = headTag.getAttribute('data-location');
    let headPhone = headTag.getAttribute('data-phone');
    let headEmail = headTag.getAttribute('data-email');

    if (!selectedCity && headCity) {
      setCookie('selectedCity', headCity, 3);
      selectedCity = headCity;
    }
    if (!selectedPhone && headPhone) {
      setCookie('selectedPhone', headPhone, 3);
      selectedPhone = headPhone;
    }
    if (!selectedEmail && headEmail) {
      setCookie('selectedEmail', headEmail, 3);
      selectedEmail = headEmail;
    }
  }
}

const noPhoneSwap = getElement('body').classList.contains('no-phone-swap');
if (!noPhoneSwap) {
  document.addEventListener('DOMContentLoaded', function (event) {
    setDefaultValueForCitySelect();

    installThePixel(selectedCity);
    // If there's a selected phone, replace all phone numbers on the page
    if (selectedPhone) {
      replacePhoneNumbers(selectedPhone);
    }

    if (selectedEmail) {
      setEmailFromCookie(selectedEmail);
    }
    citySelectEvent();
    replaceKeywordsWithCity(selectedCity);
  });
}


// Function to load the Nextdoor Pixel Codes
function loadNextdoorPixelCodes() {
  var head = document.getElementsByTagName('head')[0];
  console.log('nextdoor pixel events on cf7 submit');
  // First Nextdoor Pixel Code
  var nextdoorScript1 = document.createElement('script');
  nextdoorScript1.type = 'text/javascript';
  nextdoorScript1.innerHTML = `
    (function(win, doc, sdk_url){
      if(win.ndp) return;
      var tr=win.ndp=function(){
        tr.handleRequest? tr.handleRequest.apply(tr, arguments):tr.queue.push(arguments);
      };
      tr.queue = [];
      var s='script';
      var new_script_section=doc.createElement(s);
      new_script_section.async=!0;
      new_script_section.src=sdk_url;
      var insert_pos=doc.getElementsByTagName(s)[0];
      insert_pos.parentNode.insertBefore(new_script_section, insert_pos);
    })(window, document, 'https://ads.nextdoor.com/public/pixel/ndp.js');
    
    ndp('init','3ad23803-3e4a-41a1-a11e-f97ca59d5533', {});
    ndp('track','CONVERSION');
  `;
  head.appendChild(nextdoorScript1);

  var noscript1 = document.createElement('noscript');
  var noscript1Img = document.createElement('img');
  noscript1Img.height = "1";
  noscript1Img.width = "1";
  noscript1Img.style.display = "none";
  noscript1Img.src = "https://flask.nextdoor.com/pixel?pid=3ad23803-3e4a-41a1-a11e-f97ca59d5533&ev=CONVERSION&noscript=1";
  noscript1.appendChild(noscript1Img);
  head.appendChild(noscript1);

  // Second Nextdoor Pixel Code
  var nextdoorScript2 = document.createElement('script');
  nextdoorScript2.type = 'text/javascript';
  nextdoorScript2.innerHTML = `
    (function(win, doc, sdk_url){
      if(win.ndp) return;
      var tr=win.ndp=function(){
        tr.handleRequest? tr.handleRequest.apply(tr, arguments):tr.queue.push(arguments);
      };
      tr.queue = [];
      var s='script';
      var new_script_section=doc.createElement(s);
      new_script_section.async=!0;
      new_script_section.src=sdk_url;
      var insert_pos=doc.getElementsByTagName(s)[0];
      insert_pos.parentNode.insertBefore(new_script_section, insert_pos);
    })(window, document, 'https://ads.nextdoor.com/public/pixel/ndp.js');
    
    ndp('init','6d585239-6130-4772-8722-0ba85337b160', {});
    ndp('track','CONVERSION');
  `;
  head.appendChild(nextdoorScript2);

  var noscript2 = document.createElement('noscript');
  var noscript2Img = document.createElement('img');
  noscript2Img.height = "1";
  noscript2Img.width = "1";
  noscript2Img.style.display = "none";
  noscript2Img.src = "https://flask.nextdoor.com/pixel?pid=6d585239-6130-4772-8722-0ba85337b160&ev=CONVERSION&noscript=1";
  noscript2.appendChild(noscript2Img);
  head.appendChild(noscript2);
}

// Event listener for Contact Form 7 submission
document.addEventListener('wpcf7mailsent', function (event) {
  if (getCookie('selectedCity') === 'Indianapolis') {
    loadNextdoorPixelCodes();
  }
}, false);
